import React from 'react';

export function blank() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF" cx="12" cy="12" r="12" />
        <circle stroke="#C6D3D9" cx="12" cy="12" r="11.5" />
      </g>
    </svg>
  );
}

export function current() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <defs>
        <path
          d="M12 11a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8zm-5.6 0a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8zm11.2 0a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8z"
          id="horizontal-round-icon"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF" cx="12" cy="12" r="12" />
        <circle stroke="#0C60A5" strokeWidth="2" cx="12" cy="12" r="11" />
        <use fill="#0C60A5" href="#horizontal-round-icon" />
      </g>
    </svg>
  );
}

export function error() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#DB232D" cx="12" cy="12" r="12" />
        <circle stroke="#DB232D" cx="12" cy="12" r="11.5" />
        <path
          d="M13.513 12.043l2.272-2.275a1.08 1.08 0 00-.1-1.41 1.076 1.076 0 00-1.408-.1l-2.315 2.233-2.24-2.275a1.076 1.076 0 00-1.407.1 1.08 1.08 0 00-.1 1.41l2.283 2.317-2.272 2.232a1.08 1.08 0 00.1 1.41c.379.379.979.421 1.408.1l2.228-2.286 2.272 2.275c.429.322 1.029.279 1.408-.1.378-.38.421-.98.1-1.41l-2.23-2.22z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export function success() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#0C60A5" cx="12" cy="12" r="12" />
        <circle stroke="#0C60A5" strokeWidth="2" cx="12" cy="12" r="11" />
        <path
          d="M11.428 15.678a1.03 1.03 0 01-1.495 0L7.438 13.16a1.182 1.182 0 01-.42-1.128c.073-.43.371-.778.767-.896.396-.119.82.014 1.094.341l1.72 1.775 4.55-4.9a1.034 1.034 0 011.035-.317c.373.099.668.402.774.796.106.393.007.817-.26 1.112l-5.27 5.736z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export function number(num: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF" cx="12" cy="12" r="12" />
        <circle stroke="#0C60A5" strokeWidth="2" cx="12" cy="12" r="11" />
        <text
          x="7.8"
          y="17"
          fontFamily="Source Sans Pro"
          fontWeight="700"
          fontSize="16"
          fill="#0C60A5"
        >
          {num}
        </text>
      </g>
    </svg>
  );
}

export function numberSolid(num: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#0C60A5" cx="12" cy="12" r="12" />
        <circle stroke="#0C60A5" stroke-width="2" cx="12" cy="12" r="11" />
        <text
          x="8"
          y="17"
          fontFamily="Source Sans Pro"
          fontWeight="700"
          fontSize="16"
          fill="#FFF"
        >
          {num}
        </text>
      </g>
    </svg>
  );
}
